import React, { useState } from "react";

import "./rating.css";

import elly from "../../../assets/img/elly.png";

import axios from "axios";
import { PORT } from "../../../config";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
// import TabList from './tab-list'
import Badge from "./badge";
import { notify } from "react-notify-toast";
import { API } from "../../../API";
const Rating = (props) => {
  const classId = window.location.search.substring(1).split("cid=")[1];
  const [teacher, setTeacher] = useState(props.location.state.teacher);
  // console.log(teacher)
  // booking_id field in mongodb booking data might not be used anymore
  const [booking_ids, setbookings] = useState(props.location.state.booking_ids);
  const [date, setDate] = useState(props.location.state.date);
  const teacherName = teacher
    ? teacher.first_name + " " + teacher.last_name[0] || "Teacher Ready"
    : "Teacher Ready";
  const teacherDate = date ? date || "-" : "-";
  console.log(props.location.state)
  const badges = [
    { title: "Adaptable", iconURL: "./feedbackIcons/Adaptable.png" },
    { title: "Arrives Early", iconURL: "./feedbackIcons/arrivesEarly.png" },
    { title: "Creative", iconURL: "./feedbackIcons/Creative.png" },
    { title: "Energetic", iconURL: "./feedbackIcons/Energetic.png" },
    {
      title: "Engages Students",
      iconURL: "./feedbackIcons/engagesStudents.png",
    },
    { title: "Fun Teacher", iconURL: "./feedbackIcons/funTeacher.png" },
    { title: "Knows the Field", iconURL: "./feedbackIcons/knowsTheField.png" },
    { title: "On the Ball", iconURL: "./feedbackIcons/onTheBall.png" },
    { title: "Organised", iconURL: "./feedbackIcons/Organised.png" },
    { title: "Quiet Achiever", iconURL: "./feedbackIcons/quietAchiever.png" },
    { title: "Reliable", iconURL: "./feedbackIcons/Reliable.png" },
    { title: "Resourceful", iconURL: "./feedbackIcons/Resourceful.png" },
  ];

  const q_badge = [
    "Reading",
    "Writing",
    "Vocabulary",
    "Grammar",
    "Speaking",
    "Marking assements",
    "Quality",
    "Skills",
    "Knowledge",
  ];
  const g_badge = [
    "assessment_delivery",
    "grammar_guru",
    "listening_guru",
    "marking_assessment",
    "reading_guru",
    "speaking/pron",
    "vocabulary_guru",
    "writing_guru",
  ];
  const s_badge = ["above&beyond", "above&beyond", "above&beyond"];
  const badgeList = [q_badge, g_badge, s_badge];
  const [open, setOpen] = useState(true);
  const [sending, setSending] = useState(false);
  const [currentStep, setStep] = useState("step1");
  const [selectedBadge, setSelectedBadge] = useState([]);
  const [notes, setNotes] = useState("");
  const submitFeedback = async (teacher_id, feedback) => {
    try {
      setStep("step2");
      await API.updateFeedback({
        teacher_id,
        feedback_text: feedback,
        summary: badgeToString(),
      });
      setSending("succesfully");
      setOpen(true);
      setStep("step3");
      setSending(false);
    } catch (error) {
      setSending("error");
      setSending(false);
    }
    setSending(true);
    setSending(false);
  };

  const errorMessage = () => {
    if (sending === "error") {
      return "Error Sending Data 404 please refresh and try again";
    }
  };

  const badgeToString = () => {
    let result = "";
    if (selectedBadge.length > 0) {
      result = `'${selectedBadge[0]}'`;
      for (let i = 1; i < selectedBadge.length; i++) {
        result += `, '${selectedBadge[i]}'`;
      }
    }
    return result;
  };

  const handleClickBadge = (title) => {
    const newSelected = [...selectedBadge];
    const index = newSelected.indexOf(title);
    if (index > -1) {
      newSelected.splice(index, 1);
    } else if (newSelected.length >= 3) {
      notify.show("You can only select 3 badges ");
    } else {
      newSelected.push(title);
    }
    setSelectedBadge(newSelected);
  };
  const handleSubmit = () => {
    const badges = selectedBadge.map((badge) => {
      return {
        badge_title: badge,
      };
    });
    submitFeedback(teacher?._id, {
      booking_ids: booking_ids,
      badges: badges,
      detail: notes,
    });
  };
  const renderComponent = {
    step1: {
      headingTitle: () => (
        <h3 className="rating-header">
          Hi, Elly here. I'm checking in to see how{" "}
          <strong>{teacherName}</strong>'s recent classes went.
          {/* <strong> {teacherDate}</strong>. */}
          <br />
          Please assign <b>UP TO</b> 3 badges to them.
        </h3>
      ),
      selectTitle: null,
      component: () => generateBadge(),
    },

    step2: {
      headingTitle: () => {
        return (
          <div className="sending-data-content">
            <h1>Sending Data ...</h1>
            <CircularProgress color="inherit" className="circular-progress" />
          </div>
        );
      },
      selectTitle: "",
      component: null,
    },
    step3: {
      headingTitle: () => (
        <div className="submit-content">
          <div className="submit-title">
            Thank you for providing valuable feedback for our teachers.
          </div>
          <div className="submit-body">
            {/* <div>To make another booking, simply send me an SMS.</div> */}
            <div>Bye for now!</div>
            {/* <div className="loding-flex-center"> */}
            <div className="flex-center">
              <img alt="Elly Goodbye" src={elly} className="elly-goodbye" />
            </div>

            <div>
              Elly Elicos
              {/* <br />
              Your VADoS */}
            </div>
          </div>
        </div>
      ),
      selectTitle: "",
      component: () => null,
    },
  };
  const generateBadge = () => {
    return (
      <div className="badges-container">
        {badges.map((list, index) => {
          return (
            <Badge
              title={list.title}
              key={index}
              iconURL={list.iconURL}
              onClick={() => handleClickBadge(list.title)}
              activeClass={selectedBadge.indexOf(list.title) > -1}
            />
          );
        })}
      </div>
    );
  };
  const renderButton = () => {
    if (
      currentStep === "step1" &&
      selectedBadge.length > 0 &&
      selectedBadge.length <= 3
    ) {
      return (
        <div className="selection-confirm">
          <p className="submit-confirmation">
            You're adding {badgeToString()} badge to{" "}
            <span className="teacher-name">{teacherName}</span>'s Profile.{" "}
          </p>
          <textarea
            placeholder="Write a positive comment to add to the teacher’s Profile. (Optional)"
            className="rating-note"
            onChange={(e) => setNotes(e?.target?.value)}
          />
          <button
            onClick={handleSubmit}
            className="submitButton"
            id="submitButton"
          >
            SUBMIT
          </button>
        </div>
      );
    } else {
      return (
        <div className="selection-confirm">
          <p className="submit-confirmation">Please select one badge. </p>
        </div>
      );
    }
  };

  const renderElly = () => {
    if (currentStep === "step1") {
      return (
        <img src={elly} alt="elly" id="elly" className="rating_pic_right" />
      );
    }
  };

  return (
    <>
      {teacher ? (
        <div className="rating-container">
          <div className="row header-logo">
            <img
              src="../../../assets/img/logo.png"
              alt="logo"
              className="rating_logo_left"
            />
            {renderElly()}
          </div>
          {renderComponent[currentStep].headingTitle()}

          {currentStep === "step1" ? (
            <div className="body-wrapper">
              <h4>{renderComponent[currentStep].selectTitle}</h4>
              <div className="badge-wrapper">
                <div>{renderComponent[currentStep].component()}</div>
                {renderButton()}
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <>
          <Backdrop className="rating-backdrop" open={true}>
            <div>
              <div className="loding-flex-center">
                <img src="../../../assets/img/logo.png" alt="" />
              </div>
              {errorMessage}
            </div>
          </Backdrop>
        </>
      )}
    </>
  );
};

export default Rating;
